"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Application error:", error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
      <h1 className="text-3xl  mb-4">Something went wrong</h1>
      <p className="text-neutral-600 mb-6 max-w-md">
        {error?.message || 'We apologize for the inconvenience. An unexpected error has occurred.'}
      </p>
      <Button onClick={reset}>Try again</Button>
    </div>
  );
}
